{{#each dataRecords}}
	<div class="row m-b-10">
		{{#if hasValues}}
		<div class="col-sm-6">
			<label>{{name}}</label>
			{{!--  dropdown for values of the current device using bootstrap selectpicker  --}}
			{{#SELECT valueID}}
			<select {{#unless ../isVisible}}disabled="disabled"{{/unless}}
				id="js-value-select-{{@index}}"
				class="selectpicker"
				data-live-search="true"
				data-style="btn-white"
				data-title="-">
				{{#each this.valueList.models}}
					<option value="{{this.attributes.id}}">{{TR_DATAPOINT this.device this.attributes.name}}</option>
				{{/each}}
			</select>
			{{/SELECT}}
		</div>
		{{/if}}
		<div class="col-sm-{{#if hasValues}}6{{else}}12{{/if}}">
			<label>{{TR 'Gerät'}}</label>
			{{!--  dropdown for the devices using bootstrap selectpicker  --}}
			{{#DEVICE_SELECT deviceID ../disabled}}
			<select
				id="js-device-select-{{@index}}"/>
			{{/DEVICE_SELECT}}
		</div>
	</div>
{{/each}}
